import { NeedsListView } from '@features/needs/components/NeedsListView'
import {
  useNeedsInfiniteQuery,
  type UseNeedsInfiniteQueryOptions,
} from '@features/needs/infinite/useNeedsInfiniteQuery'
import { white } from '@themes/Colors'
import * as React from 'react'
import { StyleSheet } from 'react-native'

interface Props {
  options: UseNeedsInfiniteQueryOptions<any, any, any, any>
}

export function NeedsListComposed(props: Props) {
  const query = useNeedsInfiniteQuery({
    ...props.options,
    enabled: typeof window !== 'undefined',
  })
  return (
    <NeedsListView
      isLoading={query.isLoading}
      isError={query.isError}
      pages={query.data?.pages}
      hasNextPage={query.hasNextPage}
      fetchNextPage={query.fetchNextPage}
      isFetchingNextPage={query.isFetchingNextPage}
      containerProps={{
        style: styles.routeContainer,
      }}
      itemProps={{
        containerProps: {
          style: {
            marginBottom: 16,
          },
        },
      }}
    />
  )
}

const styles = StyleSheet.create({
  routeContainer: {
    flexGrow: 1,
    flexShrink: 0,
    padding: 12,
    backgroundColor: white,
  },
})
